import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

const PaymentMethodModel = ({
  show,
  handleClose,
  paymentMethod,
  bankAccounts,
  chequeDetails,
  setChequeDetails,
  selectedBankAccount,
  setSelectedBankAccount,
  handleSubmit,
  currencyCode,
  userId,
}) => {
  const handleChequeChange = (e) => {
    const { name, value } = e.target;
    setChequeDetails((prev) => ({
      ...prev,
      [name]: value,
      userId: userId,
    }));
  };

  // Get selected bank account details
  const selectedBank = bankAccounts.find(
    (b) => b.companyBankAccountId === chequeDetails.companyBankAccountId
  );

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="py-2">
        <Modal.Title className="h6 mb-0">
          {paymentMethod === "BANKACCOUNT"
            ? "Bank Account Details"
            : "Cheque Details"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-3">
        {paymentMethod === "BANKACCOUNT" && (
          <div className="mb-3">
            <label className="form-label fw-semibold mb-2">
              Select Bank Account
            </label>
            <select
              className="form-select"
              value={selectedBankAccount}
              onChange={(e) => setSelectedBankAccount(e.target.value)}
              required
            >
              <option value="">Select Bank Account</option>
              {bankAccounts.map((account) => (
                <option
                  key={account.companyBankAccountId}
                  value={account.companyBankAccountId}
                >
                  {account.bankName} - {account.accountName} (
                  {account.accountNo})
                </option>
              ))}
            </select>
          </div>
        )}

        {paymentMethod === "CHEQUE" && (
          <div className="row g-3">
            <div className="col-md-8">
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <Form.Group controlId="bankAccountSelect">
                    <Form.Label className="fw-semibold mb-1">
                      Bank Account *
                    </Form.Label>
                    <Form.Select
                      name="companyBankAccountId"
                      value={chequeDetails.companyBankAccountId}
                      onChange={handleChequeChange}
                      required
                    >
                      <option value="">Select Bank Account</option>
                      {bankAccounts.map((account) => (
                        <option
                          key={account.companyBankAccountId}
                          value={account.companyBankAccountId}
                        >
                          {account.bankName} - {account.accountNo}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </div>

                <div className="col-12 col-md-6">
                  <Form.Group controlId="chequeNumber">
                    <Form.Label className="fw-semibold mb-1">
                      Cheque Number *
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="chequeNumber"
                      value={chequeDetails.chequeNumber}
                      onChange={handleChequeChange}
                      placeholder="Enter cheque number"
                      required
                    />
                  </Form.Group>
                </div>

                <div className="col-12 col-md-6">
                  <Form.Group controlId="issueDate">
                    <Form.Label className="fw-semibold mb-1">
                      Issue Date *
                    </Form.Label>
                    <Form.Control
                      type="date"
                      name="issueDate"
                      value={chequeDetails.issueDate}
                      onChange={handleChequeChange}
                      required
                    />
                  </Form.Group>
                </div>

                <div className="col-12 col-md-6">
                  <Form.Group controlId="clearedDate">
                    <Form.Label className="fw-semibold mb-1">
                      Cleared Date
                    </Form.Label>
                    <Form.Control
                      type="date"
                      name="clearedDate"
                      value={chequeDetails.clearedDate || ""}
                      onChange={handleChequeChange}
                    />
                  </Form.Group>
                </div>

                <div className="col-12 col-md-6">
                  <Form.Group controlId="amount">
                    <Form.Label className="fw-semibold mb-1">
                      Amount ({currencyCode}) *
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="amount"
                      value={chequeDetails.amount}
                      onChange={handleChequeChange}
                      placeholder="0.00"
                      required
                      step="0.01"
                    />
                  </Form.Group>
                </div>

                <div className="col-12 col-md-6">
                  <Form.Group controlId="status">
                    <Form.Label className="fw-semibold mb-1">Status</Form.Label>
                    <Form.Select
                      name="status"
                      value={chequeDetails.status}
                      onChange={handleChequeChange}
                    >
                      <option value="Issued">Issued</option>
                      <option value="Cleared">Cleared</option>
                      <option value="Bounced">Bounced</option>
                      <option value="Pending">Pending</option>
                    </Form.Select>
                  </Form.Group>
                </div>

                <div className="col-12">
                  <Form.Group controlId="remarks">
                    <Form.Label className="fw-semibold mb-1">
                      Remarks
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="remarks"
                      value={chequeDetails.remarks}
                      onChange={handleChequeChange}
                      placeholder="Optional remarks"
                    />
                  </Form.Group>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card h-100 border">
                <div className="card-header py-2 bg-light">
                  <h6 className="mb-0 fw-semibold">Selected Bank Details</h6>
                </div>
                <div className="card-body p-3">
                  {selectedBank ? (
                    <div>
                      <div className="mb-2">
                        <div className="text-muted small">Bank</div>
                        <div className="fw-semibold">
                          {selectedBank.bankName}
                        </div>
                      </div>
                      <div className="mb-2">
                        <div className="text-muted small">Account</div>
                        <div className="fw-semibold">
                          {selectedBank.accountName}
                        </div>
                      </div>
                      <div className="mb-2">
                        <div className="text-muted small">Account No</div>
                        <div className="fw-semibold">
                          {selectedBank.accountNo}
                        </div>
                      </div>
                      <div className="mb-2">
                        <div className="text-muted small">IFSC</div>
                        <div className="fw-semibold">{selectedBank.ifsc}</div>
                      </div>
                      <div className="mb-2">
                        <div className="text-muted small">Branch</div>
                        <div className="fw-semibold">{selectedBank.branch}</div>
                      </div>
                    </div>
                  ) : (
                    <div className="text-muted small">
                      Select a bank account to view details
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="py-2">
        <Button variant="danger" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PaymentMethodModel;
